import React, { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformAccountMetaConfigurationModal = ({
  platformName,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  const [metaAdsAccountId, setMetaAdsAccountId] = useState("");
  const [availableUserMetaAccountsIds, setAvailableUserMetaAccountsIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulate API calls to fetch dropdown options
    const fetchSelectedData = async () => {
      try {
        const response = await getRequest(
          "/api/ads/meta/fetch-meta-ads-account"
        )

        console.log("response: ", response);

        const responseData = response.data;

        if(responseData && responseData['meta_ads_account_id']) {
          setMetaAdsAccountId(responseData['meta_ads_account_id'])
        }

      } catch (err) {
        console.error("Error fetching selected data", err);
        setError("Failed to fetch selected data or does not exist.");
      }
    };

    const fetchAvailableUserMetaAccountIds = async () => {
      try {
        const response = await getRequest(
          "/api/ads/meta/fetch-available-ad-account-ids"
        )

        const responseData = response.data;

        console.log("responseData: ", responseData);

        if(responseData) {
          setAvailableUserMetaAccountsIds(responseData)
        }

      } catch (err) {
        console.error("Error fetching dropdown options", err);
        setError("Failed to fetch dropdown options.");
      }
    };

    fetchAvailableUserMetaAccountIds()
    fetchSelectedData();
  }, []);


  const saveMetaAccessToken = async () => {
    // Check if all fields are filled
    if (!metaAdsAccountId) {
      setError("All fields are required!");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Replace the URL with your actual API endpoint
      await postRequest(
        "/api/ads/meta/save-meta-ads-account",
        {
          metaAdsAccountId: metaAdsAccountId,
        }
      );

      toast.success("Meta Access Token updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      console.error(err);
      setError("An error occurred while saving the access token for Meta.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* API Key, API Secret, Admin API Access Token Inputs */}
      {/* <div className="space-y-4">
        <div className="mb-3">
          <label
            htmlFor="metaAdsAccountId"
            className="block text-sm font-medium text-gray-700"
          >
            Ad Account ID
          </label>
          <input
            type="text"
            required="true"
            id="metaAdsAccountId"
            className="mt-1 p-2 w-full border rounded-lg"
            value={metaAdsAccountId}
            onChange={(e) => setMetaAdsAccountId(e.target.value)}
            placeholder="123456789012345"
          />
        </div>
      </div> */}

      <div className="space-y-4">
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Meta Ads Account ID
            </label>
            <select
              value={metaAdsAccountId}
              onChange={(e) => setMetaAdsAccountId(e.target.value)}
              className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10" 
            >
              <option value="" disabled>
                Select Meta Account ID
              </option>
              {availableUserMetaAccountsIds.map((option) => (
                <option key={option.adAccountId} value={option.adAccountId}>
                  {`${option.adAccountId} (${option.name})`}
                </option>
              ))}
            </select>

            {/* Liste vide = le PROFIL FACEBOOK connecté n'a accès à aucun
                compte pub (vérifié : Meta renvoie 0 adaccounts et 0 business
                malgré toutes les permissions accordées) — expliquer quoi
                faire au lieu d'un menu vide silencieux. */}
            {availableUserMetaAccountsIds.length === 0 && (
              <div className="mt-3 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 text-xs text-amber-800 space-y-1.5">
                <p className="font-bold">⚠️ Aucun compte publicitaire accessible avec ce profil Facebook.</p>
                <p>Le profil connecté n'a de rôle sur aucun compte publicitaire ni Business Manager. Deux solutions :</p>
                <p>1. <b>Reconnectez-vous avec le profil Facebook qui gère vos pubs</b> (celui utilisé dans Ads Manager), ou</p>
                <p>2. Dans <b>business.facebook.com → Paramètres → Personnes</b>, donnez à ce profil un accès à vos comptes publicitaires, puis rouvrez cette fenêtre.</p>
              </div>
            )}
          </div>
        </div>

      {/* Note/Disclaimer */}
      <div className="text-xs text-gray-500 italic mb-6">
        The ID of your Meta Ads account
      </div>

      {/* Error Message */}
      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      {/* Buttons */}
      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={saveMetaAccessToken}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountMetaConfigurationModal;
